<script lang="ts" setup>
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue'
import { Chat } from '@/ui/widget/chat'
import { useAgentsLibraryStore } from '@/store/task-library'
import { storeToRefs } from 'pinia'
import { useRoute } from 'vue-router'
import TextView from '@/ui/common/text-view/TextView.vue'
import { IAgent } from '@/api/modules/task-library/types'
import { useThreadsStore } from '@/store/threads-store'
import { useChatHistoryPageStore } from '@/store/chat-history-page'
import { useI18n } from 'vue-i18n'

const route = useRoute()

// const { locale } = useI18n()

const threadId = computed(() => route.params.id as string)

const threadsStore = useThreadsStore()
const { getThreadInfo, resetThread } = threadsStore

const { thread } = storeToRefs(threadsStore)

const chatHistoryPageStore = useChatHistoryPageStore()

const agentsLibraryStore = useAgentsLibraryStore()

const { agentsItems } = storeToRefs(agentsLibraryStore)

const { getChatCategories } = chatHistoryPageStore

const chatRef = ref<any>()

const handleCreateThread = async (command: string) => {
  if (chatRef.value) {
    chatRef.value.submitUserMessage({ text: command })
  }
}

const agent = computed(() => {
  return agentsItems.value.find((a: IAgent) => a.name == thread.value?.agent_name)
})

watch(
  () => threadId.value,
  async (val: string) => {
    await getThreadInfo(val)
    await getChatCategories()
    if (chatRef.value) {
      // chatRef.value.setThreadId(val)
    }
  },
)

/*
watch(
  () => locale.value,
  async () => {
    if (threadId.value) {
      await agentsLibraryStore.getAgentsItems()
    }
  },
)*/

onMounted(async () => {
  if (threadId.value) {
    await getChatCategories()
    await getThreadInfo(threadId.value)
  }
})

onBeforeUnmount(() => {
  resetThread()
})
</script>
<template>
  <Chat ref="chatRef" :key="threadId" :thread-id="threadId" :isShowGreeting="!thread?.last_message">
    <h4>{{ agent?.greeting }}</h4>
    <div class="command">
      <a-button
        v-for="command in agent?.start_commands"
        v-on:click="handleCreateThread(command)"
        class="command__button"
      >
        <TextView variant="roboto_13_medium">{{ command }}</TextView>
      </a-button>
    </div>
  </Chat>
</template>
<style lang="scss" scoped>
.emptyContent {
  font-family: var(--main_font);
}
</style>
